import {RequestFactory} from "@/requests/RequestFactory";

export default {
    fetchAllItems ({state, commit}, {resource}) {
        return new Promise((resolve, reject) => {
            RequestFactory.get(resource).findAll().then(response => {
                response.data.forEach(item =>  commit('setItem', {item, resource}))
                resolve(state[resource].items)
            }, error => reject(error))
        })
    },

    fetchItem ({state, commit}, {id, resource}) {
        return new Promise((resolve, reject) => {
            RequestFactory.get(resource).findById(id).then(response => {
                const item = response.data
                commit('setItem', {item, resource})
                resolve(state[resource].items[id])
            }, error => reject(error))
        })
    },

    fetchItemsParent ({state, commit}, {id, resource}) {
        return new Promise((resolve, reject) => {
            RequestFactory.get(resource).findByParentId(id).then(response => {
                response.data.forEach(item =>  commit('setItem', {item, resource}))
                resolve(state[resource].items)
            }, error => reject(error))
        })
    },

    fetchIntervencoesByProjeto ({state, dispatch, commit, getters, rootGetters}, {id, resource}) {
        dispatch, commit, getters, rootGetters
        return new Promise((resolve, reject) => {
            RequestFactory.get(resource).findByParentId(id).then(response => {
                let intervencoes = response.data


                intervencoes.forEach((entry) => {
                    let indicadores = rootGetters["indicador/byLogicaIntervencaoId"](entry.id)
                    let resumoIndicador = {}
                    let progressoLogicaIntervencao = 0.00
                    resumoIndicador['progressoIndicadores'] = 0.00
                    resumoIndicador['numeroDeIndicadores'] = indicadores.length
                    resumoIndicador['indicadoresConcluidos'] = indicadores.filter(item => item.porcentagemTotalAtingido >= 100).length
                    
                    if (resumoIndicador.numeroDeIndicadores) {
                      let sum = parseFloat(indicadores.reduce((accumulator, object) => { return accumulator + object.porcentagemTotalAtingido;}, 0.00))
                      resumoIndicador['progressoIndicadores'] = parseFloat(parseFloat(sum / resumoIndicador.numeroDeIndicadores).toFixed(2))
                      progressoLogicaIntervencao = resumoIndicador.progressoIndicadores
                    }
          
                    //const payload = { 'logicaIntervencaoId': entry.id, 'resumoIndicador': resumoIndicador }
                    //commit('logicaIntervencao/SET_RESUMO_INDICADOR', payload, { root: true })
                    //commit('SET_RESUMO_INDICADOR', payload, { root: true })
                    entry['resumoIndicador'] = resumoIndicador
                    
                    //const payloadProgresso = { 'logicaIntervencaoId': entry.id, 'progressoLogicaIntervencao': progressoLogicaIntervencao }
                    //commit('logicaIntervencao/SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
                    //commit('SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
                    entry['progressoLogicaIntervencao'] = progressoLogicaIntervencao
                    

                  });

                  let produtos = intervencoes.filter(logicaIntervencao => logicaIntervencao.nivel === "RESULTADO_ESPERADO")


                  produtos.forEach((produto) => {
                    produto["atividades"] = intervencoes.filter(logicaIntervencao => logicaIntervencao.logicaIntervencao && logicaIntervencao.logicaIntervencao.id === produto.id && logicaIntervencao.nivel === 'ATIVIDADE')
                    let progressoLogicaIntervencao = 0.00
                    let resumoAtividade = {}
                    resumoAtividade['progressoAtividades'] = 0.00
                    resumoAtividade['numeroDeAtividades'] = produto.atividades.length
                    resumoAtividade['atividadesConcluidas'] = produto.atividades.filter(item => item.resumoIndicador.progressoIndicadores >= 100).length
          
          
                    if (resumoAtividade.numeroDeAtividades) {
                      let sum = parseFloat(produto.atividades.reduce((accumulator, object) => { return accumulator + object.resumoIndicador.progressoIndicadores;}, 0.00))
                      resumoAtividade['progressoAtividades'] = parseFloat(parseFloat(sum / resumoAtividade.numeroDeAtividades).toFixed(2))
                      progressoLogicaIntervencao = parseFloat(parseFloat(parseFloat(resumoAtividade.progressoAtividades + produto.resumoIndicador.progressoIndicadores) / 2).toFixed(2))
                    }
          
                    //const payload = { 'logicaIntervencaoId': produto.id, 'resumoAtividade': resumoAtividade }
                    //commit('logicaIntervencao/SET_RESUMO_ATIVIDADE', payload, { root: true })
                    //commit('SET_RESUMO_ATIVIDADE', payload, { root: true })
                    produto['resumoAtividade'] = resumoAtividade
          
                    //const payloadProgresso = { 'logicaIntervencaoId': produto.id, 'progressoLogicaIntervencao': progressoLogicaIntervencao }
                    //commit('logicaIntervencao/SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
                    //commit('SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
                    produto['progressoLogicaIntervencao'] = progressoLogicaIntervencao
                  });
          
          




                intervencoes.forEach(item =>  {
                    commit('setItem', {item, resource})
                })
                resolve(state[resource].items)
            }, error => reject(error))
        })
    },
}
